import { Outlet } from "react-router-dom";
import { Typography } from "@/components/atoms";
import { Tabs } from "@/components/molecules";
import { ClientScopeProvider } from "@/components/pages/Client/settings/ClientScopeContext";
import { useManageClient } from "../context";

const favouriteTabs = [
  { name: "Locations", to: "locations" },
  { name: "Guest Passengers", to: "guests" },
  { name: "Drivers", to: "drivers" },
];

/**
 * Operator Favourites tab — reuses the client favourites tables, scoped to the managed client via `ClientScopeProvider`.
 */
export const ManageClientFavourites = () => {
  const { clientId, isViewOnly } = useManageClient();

  return (
    <ClientScopeProvider accountId={clientId}>
      {/* Full-bleed surface: -mx cancels the content wrapper's px so the gray reaches edge to edge. */}
      <div className="flex flex-1 flex-col">
        <div className="px-3 pb-12 pt-4 lg:px-5">
          <Typography variant="h2" className="mb-3 block">
            Favourites
          </Typography>

          <Tabs className="no-scrollbar min-w-0 border-b !border-neutral-mid-gray" tabs={favouriteTabs} mobileVariant="sheet" />

          {/* relative anchors the per-table "Add …" buttons (absolute -top-12 right-0); mt-3 (matching
              the client ClientFavourites shell) floats them up onto the tab row, as in the Figma.
              Removed clients are view-only (DEV-1177): disable the add/edit controls. */}
          <fieldset disabled={isViewOnly} className="relative mt-3">
            <Outlet />
          </fieldset>
        </div>
      </div>
    </ClientScopeProvider>
  );
};
